import { CartProduct } from 'smartcommerce-component-library'
import { ProductPackage } from '../../order-wizard/models/ProductPackage'

export class VehicleCartProduct extends CartProduct {
  constructor ({ id, product, name, quantity, price, groupCode, code, addons }) {
    super({ id, product: new ProductPackage(product), name, quantity, price })
    this.groupCode = groupCode
    this.code = code
    this.addons = addons
  }
}
